module.exports = __webpack_public_path__ + "static/media/icons8-docker.fe13ca4a.svg";